import React, { useEffect, useState } from "react";
import SisLoader from "../../../../widgets/loader";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";
import OtherMachineryDetailsTable from "../components/MachinaryRow";

function AuxiliaryMachinary({ id }) {
  const [loader, setLoader] = useState(false);
  const [filteredData, setFilteredData] = useState([]);

  const fetchOtherMachineryList = async () => {
    setLoader(true);
    const formData = new FormData();
    formData.append("ship_id", id);

    try {
      const res = await post(ApiURL.list_machinary_details_st, formData);
      if (res?.status === true) {
        setFilteredData(res?.response_data || []);
      }
    } catch (error) {
      console.error("Error fetching other machinery list:", error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchOtherMachineryList();
  }, []);

  return (
    <>
      <h3 style={{ margin: "15px 0", fontWeight: "600" }}>Other Machinery Information</h3>
      {loader ? (
        <SisLoader />
      ) : filteredData.length > 0 ? (
        <OtherMachineryDetailsTable data={filteredData} />
      ) : (
        <p>No data available</p>
      )}
    </>
  );
}

export default AuxiliaryMachinary;
